module.exports = __webpack_public_path__ + "img/cz-partners-finmag.87d55d03.svg";